/**
 * @module  experience/shop
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const OFFER_CONSTANTS = {
  HARDGOODS: 'HardGood',
  BASE: 'Base',
  PLANS_PLANDETAILS: 'plans/planDetails',
};

export const OFFER_TYPE = {
  ADDON: 'AddOn',
  ONDEMAND: 'OnDemand',
};

export const DEV_FINGERPRINT_ATTRIBUTES = {
  ORGID: 'deviceFingerprintOrgId',
  URL: 'deviceFingerprintUrl',
};

export const ORDER_TYPE = {
  ACTIVATION: 'ACTIVATION',
  MANAGERATEPLAN: 'MANAGERATEPLAN',
  ADDONSERVICES: 'MANAGEADDON',
  ADDALINE: 'ADDALINE',
  PURCHASEEQUIPMENT: 'PURCHASEEQUIPMENT',
  EXCHANGE: 'EXCHANGE',
  WARRANTY: 'WARRANTY',
  RETURN: 'return',
  ORDER_RETURN: 'cart/return/payment',
  RECEIPT: 'RECEIPT',
  TRANSACTION_CONFIRMATION: 'TRANSACTION_CONFIRMATION',
  REMORSE_RETURN: 'return',
  ORDER_REASON_REMORSE: 'REMORSE',
  SIM_STARTER_KIT: 'SIM Starter Kit',
  SHIPPING_LABEL: 'shippingLabel',
};
export const ORDER_STATUS = {
  INPROCESS: 'INPROCESS',
};
export const ORDER_MODULE_CONSTANT = {
  REJECT: 'REJECT',
  ACCEPT: 'ACCEPT',
  REVIEW: 'REVIEW',
};
export const PRICING_TYPE = {
  FULL: 'FULL',
  FRP: 'FRP',
  EIP: 'EIP',
};

export const NEGATIVE_CONSTANT = {
  NEGATIVE: '-',
};

export const PROCESSING_ORDER_MODAL = {
  ZERO: 0,
  MAX_LIMIT: 3,
  ONE: 1,
  SUCCESS: 'success',
  FAILED: 'failed',
  TIME_DELAY: 2000,
};

export const FLAG_STATUS = {
  YES: 'YES',
  NO: 'NO',
};

export enum DateFormat {
  'MM/dd/yyyy',
}
